var POPUP_CLASS_BY_NAME = {
  "POWER UNLEASHED": "n2x",
  "Stealth Mode": "n2x",
  "noise": "n2x",
  "comfortable": "n2x_large",
  "comfortable_camo": "n2x_large"
};

var POPUP_CONTENT_BY_PAIR = {
  "discover_m|5 Modes": "<div class='pop-text-content'><div class='pb-20'>Simply select one riding mode: Eco, Trail, Sport, Boost, Auto. Each mode directly corresponds to specific riding scenarios, providing simpler operation and more consistent experience.</div><div class='pb-10'></div></div>",
  "discover_3|5 Modes": "<div class='pop-text-content'><div class='pb-20'>Simply select one riding mode: Eco, Tour, Trail, Sport, Boost. Each mode directly corresponds to specific riding scenarios, providing simpler operation and more consistent experience.</div><div class='pb-10'></div></div>",
  "summit_2|5 Modes": "<div class='pop-text-content'><div class='pb-20'>Simply select one riding mode: Eco, Trail, Sport, Boost, Pulse. Each mode directly corresponds to specific riding scenarios, providing simpler operation and more consistent experience.</div><div class='pb-10'></div></div>",
  "tempo|5 Modes": "<div class='pop-text-content'><div class='pb-20'>Simply select one riding mode: Eco, Trail, Sport, Boost, Pulse. Each mode directly corresponds to specific riding scenarios, providing simpler operation and more consistent experience.</div><div class='pb-10'></div></div>",
  "Gomad|5 Modes": "<div class='pop-text-content'><div class='pb-20'>Simply select one riding mode: Eco, Trail, Sport, Boost, Stealth. Each mode directly corresponds to specific riding scenarios, providing simpler operation and more consistent experience.</div><div class='pb-10'></div></div>",
  "breeze_1|Low": `<div class='pop-text-content'>
    <div class='pb-20'>
      <h6>What does 'Low Motor Noise' mean?</h6>
      <div class="pb-10">Delivering mighty 750W power with industry-leading quietness, Breeze 1 operates at just 58dB - 9x quieter than average Ebike players (68dB).</div>
      <h6>Why does it matter?</h6>
      <div>A super quiet motor like Breeze 1’ means two awesome things for you:</div><div>1. Enjoy your ride in peace – No ear-piercing buzz or rumble. Hear only the sound of nature & your breath – yeah, that’s how calm it is.</div><div>2. Stay discreet – When you ride with friends, they’ll think you’re on a regular bike… because there’s barely any noise to give it away!</div>
    </div></div>`,
  "brandEdge|ul": "<div class='pop-text-content'><div class='pb-20'>UL Solutions is a global leader in safety, helping products meet the highest standards worldwide. UL Certification marks are a recognized symbol of trust, proving batteries and electrical systems are tested and safe.</div></div>",
  "fold_1_plus|torqueSensor": "<div class='pop-text-content'><div class='pb-20'>Torque Mode gives you smooth, responsive control — great for trails or climbs.</div></div>",
  "fold_1_plus|cadenceSensor": "<div class='pop-text-content'><div class='pb-20'>Cadence Mode provides constant support with light pedaling for cruising.</div></div>",
  "gomad|free_gift": `<div class="pop-text-content"><h3 class="h6 text-center">Velotric Gift Box (worth $139)</h3><img src="https://cdn.shopify.com/s/files/1/0599/2094/1239/files/gomad-freegift.webp?v=1775543708" style="width:100%;" />
      <div class="donate-content grid-content">
          <div>① Reusable Water Bottle</div>
          <div>② Velotric Cap</div>
          <div>③ Wool Socks</div>
          <div>④ Sticker Pack</div>
          <div>⑤ Ride Log Calendar</div>
          <div>⑥ Velotric Keychain</div>
    </div></div>`,
  "tempo|free_gift": `<div class="pop-text-content"><h3 class="h6 text-center">Velotric Gift Box (worth $139)</h3><img src="https://cdn.shopify.com/s/files/1/0599/2094/1239/files/velotric_tempo_gift_box.webp?v=1772274492" style="width:100%;" />
      <div class="donate-content grid-content">
          <div>① Reusable Water Bottle</div>
          <div>② Velotric Cap</div>
          <div>③ Wool Socks</div>
          <div>④ Sticker Pack</div>
          <div>⑤ Ride Log Calendar</div>
          <div>⑥ Velotric Keychain</div>
    </div></div>`,
  "folding_pillar|ComfortMax": `<div class='pop-text-content'>
    <div class='pb-20'>
      <div>ComfortMax™ combines a rear-tilted seat tube that absorbs bumps, an optimized golden-ratio frame for
                <strong>upright posture</strong>, and a <strong>400mm ultra-low step-through</strong> for effortless mounting. With <strong>60mm travel suspension
                and wide tires</strong> to soak up vibrations, every trip feels balanced and fatigue-free—even on longer rides. </div><div><small>*Selected features are exclusively available on the Fold 1 Plus model.</small></div>
    </div></div>`,
  "folding_pillar|Adaptive Power": `<div class='pop-text-content'>
    <div class='pb-20'>
      <div>With a 750W motor (1100W peak), 75Nm torque, and <strong>SensorSwap™</strong> technology, adjust power delivery in real
                time, with instant <strong>torque on hills</strong> and smooth <strong>cadence on flats</strong>. A 48V 13Ah <strong>IPX7 battery</strong> and <strong>IPX6-rated
                frame</strong> keep you rolling up to <strong>68 miles</strong>, rain or shine, with stormproof reliability every ride. </div><div><small>*Selected features are exclusively available on the Fold 1 Plus model.</small></div>
    </div></div>`,
  "folding_pillar|Smarter Folding": `<div class='pop-text-content'>
    <div class='pb-20'>
      <div>A <strong>3-step folding</strong> system and 3-minute tool-free assembly shrink the bike to a compact 37.8" x 19.7" x
                33.5" footprint—<strong>30% smaller than standard Ebikes</strong>. At just 62 lbs yet rated for a <strong>450-lb payload</strong>, it
                delivers true grab-and-go versatility without sacrificing strength, whether you’re storing, traveling,
                or commuting daily. </div><div><small>*Selected features are exclusively available on the Fold 1 Plus model.</small></div>
    </div></div>`
};

var POPUP_CONTENT_BY_NAME = {
  "5 Levels": "<div class='pop-text-content'><div class='pb-20'>Choose from 5 acceleration curves across Eco, Trail, and Boost modes, each with 5 pedal assist levels on the control panel or in the Velotric app. Adjust speed and power to match your ride—whether for efficiency, balance, or max performance.</div><div class='pb-10'></div></div>",
  "Battery IPX7": "<div class='pop-text-content'><div class='pb-20'>IPX7 Waterproof Battery, IPX6 Waterproof Bike for all-weather riding</div></div>",
  "all": '<div class="pop-text-content"><h3 class="pb-15 text-center">VELOTRIC</h3><div class="pb-15">Notice: Due to the implementation of new Tariffs, pricing on select models may increase starting <strong>April 15th, 2025</strong>. This decision is necessary to ensure that we can continue to provide the high-quality Ebikes you love, while meeting the new tariffs. You can still enjoy current prices if you purchase before April 15th. Don’t miss your chance—lock in the best deal today!</div><div class="pb-15"></div></div>',
  "POWER UNLEASHED": `<div class="pop-text-content"><img src="https://cdn.shopify.com/s/files/1/0599/2094/1239/files/Group_48101931_1.svg?v=1747220566"/><div class="donate-content">
  </div></div>`,
    "Stealth Mode": "<div class='pop-text-content'><div>Stealth Mode is co-developed with <a href='https://www.velotricbike.com/blogs/story-landing/joltbike-design-house-outdoors-ebike-brand' target='_blank'>JoltBike Design House</a>.</div></div>",
    "comfortable": `<div class="pop-text-content"><img class="mb-down--hide" src="https://cdn.shopify.com/s/files/1/0599/2094/1239/files/image_2461d594-4477-409e-ae58-f690e6aba084.webp?v=1747217457"/><img class="mb-up--hide" src="https://cdn.shopify.com/s/files/1/0599/2094/1239/files/frame_48101932.webp?v=1747217877"/><div class="donate-content">
  </div></div>`,
    "comfortable_camo": `<div class="pop-text-content"><img class="mb-down--hide" src="https://cdn.shopify.com/s/files/1/0599/2094/1239/files/comfortmax-camo-pc.webp?v=1750910447"/><img class="mb-up--hide" src="https://cdn.shopify.com/s/files/1/0599/2094/1239/files/comfortmax-camo-mb.webp?v=1750910447"/><div class="donate-content">
  </div></div>`,
    "noise": `<div class="pop-text-content"><img src="https://cdn.shopify.com/s/files/1/0599/2094/1239/files/quiet-movement-2.webp?v=1750925892"/><div class="donate-content">
  </div></div>`,
  "Customizable": `<div class='pop-text-content'><div class='pb-20'>Choose from 15 acceleration curves across Eco, Trail, and Boost modes, each with 5 pedal assist levels on the control panel or in the Velotric app. Adjust speed and power to match your ride—whether for efficiency, balance, or max performance.</div><div class='pb-10'></div></div>`
};

var POPUP_CONTENT_BY_CONTENT = {
  "key": '<img class="pop-mb-hide" src="https://cdn.shopify.com/s/files/1/0599/2094/1239/files/20240228-183235.jpg?v=1709116378" width="910" height="auto" /><img class="pop-mb-show" src="https://cdn.shopify.com/s/files/1/0599/2094/1239/files/20240228-183235.jpg?v=1709116378" width="393" height="auto" /><div class="pop-text-content"><div><p>You can locate the number in the area indicated in the picture above. The number begins with VL CT or KL, and you only need to type in the numerical digits.</p></div></div>',
  "doublepoints": '<div class="pop-text-content" style="background-color: #A4E4FF;margin:0;max-width: 100%;"><img src="https://cdn.shopify.com/s/files/1/0599/2094/1239/files/frame_48101405.webp?v=1718958091" /></div>',
  "fold_1": '<div class="pop-text-content back-in-stock"><h3>Velotric Fold 1 E-Bike</h3><div class="pb-15">Sign up to receive a notification when this item is back in stock and available to ship.</div><div class="pb-15"><input type="email" placeholder="Email" class="back_in_stock form-control" /></div><button type="submit" class="btn btn-success btn-lg col-xs-12" onclick="notifysubmit()">Notify Me When It Is In Stock</button><div id="completed_message" class="completed_message alert alert-success" style="display: none;">You are in! We will let you know when this item is back in stock and available to ship.</div></div>'
};
// function openPagePop(content, name) {
//   const popupRoot = document.querySelector("#custom_popup");
//   if (!popupRoot) return;

//   const popup = popupRoot.querySelector(".popup");
//   const popupContent = popupRoot.querySelector(".popup__content");

//   if (popup) {
//     popup.classList.remove("n2x", "n2x_large");
//     if (POPUP_CLASS_BY_NAME[name]) {
//       popup.classList.add(POPUP_CLASS_BY_NAME[name]);
//     }
//   }

//   const matchedHtml =
//     POPUP_CONTENT_BY_PAIR[`${content}|${name}`] ||
//     POPUP_CONTENT_BY_NAME[name] ||
//     POPUP_CONTENT_BY_CONTENT[content];

//   if (popupContent && matchedHtml) {
//     popupContent.innerHTML = matchedHtml;
//   } else {
//     console.warn("[openPagePop] popup content not found:", content, name);
//   }

//   if (content === "compare") {
//     let selectedProducts = [];
//     const compareListRaw = localStorage.getItem("compare_list");

//     if (compareListRaw && compareListRaw !== "undefined") {
//       try {
//         selectedProducts = JSON.parse(compareListRaw) || [];
//       } catch {
//         selectedProducts = [];
//       }
//     }

//     if (!selectedProducts.includes(name)) {
//       selectedProducts.push(name);
//       localStorage.setItem("compare_list", JSON.stringify(selectedProducts));
//     }

//     const comparePopup = document.querySelector("#compare_popup");
//     if (comparePopup) comparePopup.classList.add("active");
//     return;
//   }

//   popupRoot.classList.add("active");
// }

function openPagePop(content, name) {
  if (window.VelotricApp && window.VelotricApp.popup) {
    const eventTrigger = window.event?.target?.closest?.('[onclick*="openPagePop"]');
    window.VelotricApp.popup.open({ content: content, name: name, trigger: eventTrigger || document.activeElement });
    return;
  }

  console.warn("[openPagePop] App.popup is not ready yet", content, name);
}

function onVelotricReady(callback) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', callback, { once: true });
    return;
  }
  callback();
}

function slideElement(element, shouldExpand, duration) {
  if (!element) return;

  var animationDuration = typeof duration === 'number' ? duration : 300;
  if (element._velotricSlideAnimation) {
    element._velotricSlideAnimation.cancel();
  }

  var currentDisplay = window.getComputedStyle(element).display;
  if (!shouldExpand && currentDisplay !== 'none') {
    element.dataset.velotricDisplay = currentDisplay;
  }

  if (shouldExpand && currentDisplay === 'none') {
    element.style.display = element.dataset.velotricDisplay || 'grid';
  }

  var startHeight = element.getBoundingClientRect().height;
  var endHeight = shouldExpand ? element.scrollHeight : 0;

  function finish() {
    element.style.removeProperty('height');
    element.style.removeProperty('overflow');
    if (!shouldExpand) {
      element.style.display = 'none';
    }
    element._velotricSlideAnimation = null;
  }

  if (!element.animate || animationDuration <= 0 || startHeight === endHeight) {
    finish();
    return;
  }

  element.style.overflow = 'hidden';
  var animation = element.animate(
    [{ height: startHeight + 'px' }, { height: endHeight + 'px' }],
    { duration: animationDuration, easing: 'ease' }
  );
  element._velotricSlideAnimation = animation;
  animation.onfinish = finish;
  animation.oncancel = function () {
    element.style.removeProperty('height');
    element.style.removeProperty('overflow');
  };
}

function slideUp(element, duration) {
  slideElement(element, false, duration);
}

function slideDown(element, duration) {
  slideElement(element, true, duration);
}

function slideToggle(element, duration) {
  if (!element) return;
  var isHidden = window.getComputedStyle(element).display === 'none' || element.getBoundingClientRect().height === 0;
  slideElement(element, isHidden, duration);
}

window.VelotricDom = Object.assign(window.VelotricDom || {}, {
  ready: onVelotricReady,
  slideUp: slideUp,
  slideDown: slideDown,
  slideToggle: slideToggle
});


/*** product bundle ***/

document.addEventListener('click', function (event) {
  var expandButton = event.target.closest('#rebuy-expandButton');
  if (expandButton) {
    var controlledId = expandButton.getAttribute('aria-controls');
    var addonItems = controlledId ? document.getElementById(controlledId) : null;
    if (!addonItems) return;
    var isCollapsed = addonItems.classList.contains('rebuy-collapse');

    if (isCollapsed) {
      // ===== Show Less =====
      var prevScrollTop = Number(expandButton.dataset.scrollTop);

      // 1. 冻结滚动
      document.body.classList.add('rebuy-lock-scroll');

      // 2. 折叠 DOM
      addonItems.classList.remove('rebuy-collapse');

      // 3. 同步还原 scroll（同一帧）
      if (Number.isFinite(prevScrollTop)) {
        window.scrollTo(0, prevScrollTop);
      }

      // 4. 下一帧解锁
      requestAnimationFrame(function () {
        document.body.classList.remove('rebuy-lock-scroll');
      });
    } else {
      // ===== Show More =====
      expandButton.dataset.scrollTop = String(window.scrollY);
      addonItems.classList.add('rebuy-collapse');
    }

    expandButton.textContent = addonItems.classList.contains('rebuy-collapse') ? 'Show Less' : 'Show More';
    expandButton.setAttribute('aria-expanded', String(addonItems.classList.contains('rebuy-collapse')));

    var _window_dataLayer;   
    var breadcrumbElement = document.querySelector('.breadcrumbs .breadcrumb__link');
    const breadcrumb = breadcrumbElement ? breadcrumbElement.textContent.trim() : '';
    const buttonName = expandButton.textContent.trim();
    const parameters = { page_name: "Product Page_" + breadcrumb,button_name: buttonName,action:window.open  };
    null === (_window_dataLayer = window.dataLayer) || void 0 === _window_dataLayer ? void 0 : _window_dataLayer.push({ event: "ga4Event", event_name: "click_acc_btn", event_parameters: parameters });
    return;
  }

  var tooltip = event.target.closest('.acc-tooltip');
  if (tooltip) {
    event.preventDefault();
    event.stopPropagation();

    document.querySelectorAll('.acc-tooltip').forEach(function (item) {
      if (item !== tooltip) item.classList.remove('is-active');
    });
    tooltip.classList.toggle('is-active');
    return;
  }

  var tabButton = event.target.closest('.rebuy-wrap .acc-offer-tabs .tab-button');
  if (tabButton) {
    var wrap = tabButton.closest('.rebuy-wrap');
    var targetId = tabButton.dataset.accTabTarget;
    if (!wrap || !targetId) return;

    wrap.querySelectorAll('.acc-offer-tabs .tab-button').forEach(function (button) {
      button.classList.remove('active');
      button.setAttribute('aria-selected', 'false');
    });
    tabButton.classList.add('active');
    tabButton.setAttribute('aria-selected', 'true');

    wrap.querySelectorAll('.tab-content').forEach(function (content) {
      content.classList.remove('active');
    });
    var targetContent = wrap.querySelector('[id="' + CSS.escape(targetId) + '"]');
    if (targetContent) targetContent.classList.add('active');
    return;
  }

  document.querySelectorAll('.acc-tooltip').forEach(function (item) {
    item.classList.remove('is-active');
  });

  var footerLink = event.target.closest('.rebuy-footer a');
  if (footerLink) {
    var _window_dataLayer;   
    var footerBreadcrumbElement = document.querySelector('.breadcrumbs .breadcrumb__link');
    const breadcrumb = footerBreadcrumbElement ? footerBreadcrumbElement.textContent.trim() : '';
    const buttonName = footerLink.textContent.trim();
    const parameters = { page_name: "Product Page_" + breadcrumb,button_name: buttonName  };
    null === (_window_dataLayer = window.dataLayer) || void 0 === _window_dataLayer ? void 0 : _window_dataLayer.push({ event: "ga4Event", event_name: "click_acc_btn", event_parameters: parameters });
  }
});

document.addEventListener('keydown', function (event) {
  var tooltip = event.target.closest('.acc-tooltip');
  if (tooltip && (event.key === 'Enter' || event.key === ' ')) {
    event.preventDefault();
    tooltip.click();
  }
});

  function updateStickyAtcPrice() {
    const priceEl = document.querySelector(
      '.sticky-atc__inner [data-sticky-price]'
    );
    if (!priceEl) return;

    const basePrice = Number(priceEl.dataset.price || 0); // 分
    const accPrice  = Number(priceEl.dataset.accPrice || 0); // 分

    const finalPrice = basePrice + accPrice;
    console.log(basePrice);
    console.log(accPrice);
    console.log(finalPrice);
    const displayPrice = (finalPrice / 100).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    priceEl.innerHTML = '$' + displayPrice;
  }


  function isThreeOrMoreChecked(checkboxes) {
    let checkedCount = 0;
    let totalValue = 0;
    let totalPrice = 0;
    for (const checkbox of checkboxes) {
        if (checkbox.checked) {
            checkedCount++;
            var savedP = parseFloat(checkbox.closest(".acc-addon__item").dataset.saved);
            var originP = parseFloat(checkbox.closest(".acc-addon__item").dataset.price)
            totalValue += savedP;
            totalPrice += originP;
        }
    }
    totalValue = totalValue.toFixed(2);
    totalPrice = totalPrice.toFixed(2);
    return [checkedCount,totalValue, totalPrice];
  }

  function parseAddonPrice(price) {
    const parsedPrice = parseFloat(String(price || '').replace(/[^0-9.-]/g, ''));
    return isNaN(parsedPrice) ? 0 : parsedPrice;
  }

  function getAddonItemPrice(item) {
    if (!item) return 0;
    const select = item.querySelector('select');
    const selectedOption = select && select.selectedOptions ? select.selectedOptions[0] : null;
    const selectedPrice = selectedOption ? selectedOption.dataset.price : null;
    return parseAddonPrice(selectedPrice || item.dataset.price);
  }

  function getOfferCheckedData(container, discountRate) {
    let checkedCount = 0;
    let savedValue = 0;
    let totalPrice = 0;

    container.querySelectorAll('#offer input.acc-checkbox:checked').forEach(function (checkbox) {
      const itemPrice = getAddonItemPrice(checkbox.closest('.acc-addon__item'));
      checkedCount++;
      totalPrice += itemPrice;
      savedValue += itemPrice * discountRate;
    });

    return [checkedCount, savedValue.toFixed(2), totalPrice.toFixed(2)];
  }

  function getCheckedAddonsTotal(container, selector) {
    let totalPrice = 0;
    container.querySelectorAll(selector).forEach(function (checkbox) {
      totalPrice += getAddonItemPrice(checkbox.closest('.acc-addon__item'));
    });
    return totalPrice;
  }
  

document.addEventListener('change', function (event) {
  const checkbox = event.target.closest('.rebuy-container #offer input[type="checkbox"], .rebuy-container #bundle-offer input[type="checkbox"]');
  if (!checkbox) return;

  const container = checkbox.closest('.rebuy-container');
  if (!container) return;

  const savedText = container.querySelector('.saved_text');
  const selectedNum = container.querySelector('.selected-num');
  const salePrices = container.querySelectorAll('#offer .sale_price');
  const offerPrices = container.querySelectorAll('#offer .offer_price');
  const offerOriginPrices = container.querySelectorAll('#offer .offer-origin_price');
  const offerBundle = checkbox.closest('.offer-bundle');

  const numberedItem = container.querySelector('#offer .acc-addon__item[data-num]');
  const num = Number(numberedItem ? numberedItem.dataset.num : 0);
  const sales = Number(savedText ? savedText.dataset.sale : 0);
  const discountRate = sales > 0 ? sales / 100 : 0;
  const data  = getOfferCheckedData(container, discountRate); // data[0]: 已选数量, data[1]: 节省金额
  var totalPrice = data[2] * 1;
  var bundleTotalPrice = getCheckedAddonsTotal(container, '#bundle-offer input.acc-checkbox:checked');

  if (offerBundle) offerBundle.classList.toggle('active', checkbox.checked);
  if (num > 0) {
    if (selectedNum) selectedNum.textContent = data[0];
    if (data[0] < num) {
      if (savedText) savedText.textContent = data[0] == 0 ? `Add ${num - data[0]}, save ${sales}%` : `Add ${num - data[0]} more, save ${sales}%`;
      salePrices.forEach(function (salePrice) {
        salePrice.classList.add('hidden');
      });
      offerPrices.forEach(function (offerPrice) {
        offerPrice.classList.remove('del');
      });
      offerOriginPrices.forEach(function (offerOriginPrice) {
        offerOriginPrice.classList.remove('hidden');
      });
    } else {
      if (savedText) savedText.textContent = `Order Now & Save $${data[1]}`;
      salePrices.forEach(function (salePrice) {
        salePrice.classList.remove('hidden');
      });
      offerPrices.forEach(function (offerPrice) {
        offerPrice.classList.add('del');
      });
      offerOriginPrices.forEach(function (offerOriginPrice) {
        offerOriginPrice.classList.add('hidden');
      });
      totalPrice = totalPrice * (1 - discountRate);
    }
  }
  totalPrice += bundleTotalPrice;

  const addAccEl = document.querySelector(
    '.sticky-atc__inner .add-ons-num'
  );
  const addOnsCount = container.querySelectorAll('#offer input.acc-checkbox:checked, #bundle-offer input.acc-checkbox:checked').length;
  if(addAccEl){
    if(addOnsCount > 0){
      addAccEl.innerHTML = " + Add-ons × " + addOnsCount;
    }else{
      addAccEl.innerHTML = "";
    }
  }
  const stickyPriceEl = document.querySelector(
    '.sticky-atc__inner [data-sticky-price]'
  );

  if (stickyPriceEl) {
    // 美元 → 分
    const accPriceCents = totalPrice * 100;
    stickyPriceEl.dataset.accPrice = accPriceCents;

    updateStickyAtcPrice();
  }
});

document.addEventListener('click', function (event) {
  var card = event.target.closest('.offer-bundle');
  if (!card) return;
  var checkbox = card.querySelector('.acc-checkbox');
  if (!checkbox) return;
  
  /* -----------------------
   * 1. 排除不应触发选中的区域
   * ----------------------- */
  if (
    event.target.matches('select') ||
    event.target.closest('select') ||
    event.target.closest('.acc-addon__item-learn-more')
  ) {
    return;
  }

  /* -----------------------
   * 2. 点击 checkbox 本身
   * ----------------------- */
  if (event.target.matches('.acc-checkbox')) {
    card.classList.toggle('active', checkbox.checked);
    return;
  }

  /* -----------------------
   * 3. 点击卡片其他区域
   * ----------------------- */
  checkbox.click();
});

// acc-select change
document.addEventListener('change', function (event) {
  var select = event.target.closest('.rebuy-container #offer .acc-addon__items .acc-select, .rebuy-container #bundle-offer .acc-addon__items .acc-select, .rebuy-container #free .acc-addon__items .acc-select');
  if (!select) return;
  var selectedOption = select.selectedOptions ? select.selectedOptions[0] : null;
  var selectedPrice = selectedOption ? selectedOption.dataset.price : null;
  var selectedImage = selectedOption ? selectedOption.dataset.image : null;
  var selectedImageSrcset = selectedOption ? selectedOption.dataset.imageSrcset : null;
  var addonItem = select.closest('.acc-addon__item');
  if (!addonItem) return;
  if(selectedImage){
    var image = addonItem.querySelector('.acc-addon__item-image img');
    if (image) {
      image.src = selectedImage;
      if (selectedImageSrcset) image.srcset = selectedImageSrcset;
    }
  }
  if(selectedPrice){
    addonItem.dataset.price = String(parseAddonPrice(selectedPrice));
  }
  var checkbox = addonItem.querySelector('.acc-checkbox');
  if(checkbox && checkbox.checked){
    checkbox.dispatchEvent(new Event('change', { bubbles: true }));
  }
});
// product bundle quick view
var quickViewSourceCard = null;

document.addEventListener('click', function (event) {
  var quickViewButton = event.target.closest('.rebuy-container [data-product-card-quick-view-button]');
  if (!quickViewButton) return;
  quickViewSourceCard = quickViewButton.closest('product-card');
});

document.addEventListener('click', function (event) {
  var addAccessoryButton = event.target.closest('.quick-view__content .add-acc-btn');
  if (!addAccessoryButton) return;
  const productInfo = addAccessoryButton.closest('.product__info');
  const form = productInfo ? productInfo.querySelector('.product-form-wrap form') : null;
  if (!form) return;
  var productIdInput = form.querySelector('input[name="product-id"]');
  var variantIdInput = form.querySelector('input[name="id"]');
  var productId = Number(productIdInput ? productIdInput.value : 0);
  var variantId = variantIdInput ? variantIdInput.value : '';
  var targetCard = quickViewSourceCard;

  if (!targetCard || Number(targetCard.dataset.id) !== productId) {
    targetCard = Array.from(document.querySelectorAll('.rebuy-container #offer .acc-addon__items product-card, .rebuy-container #bundle-offer .acc-addon__items product-card')).find(function (card) {
      return Number(card.dataset.id) === productId;
    }) || null;
  }

  if (targetCard) {
    var selectElement = targetCard.querySelector('select');
    if (selectElement) {
      if (selectElement.querySelector('option[value="' + CSS.escape(variantId) + '"]')) {
        selectElement.value = variantId;
        selectElement.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    var checkbox = targetCard.querySelector('input[type="checkbox"]');
    if (checkbox) {
      checkbox.checked = true;
      checkbox.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  quickViewSourceCard = null;
  var bodyOverlay = document.querySelector('.body-overlay');
  if (bodyOverlay) bodyOverlay.click();
});
  function openTab(evt, tabName,wrapClass) {
    var i, tabcontent, tabbuttons;
    var wrap = document.querySelector("."+wrapClass);
    tabcontent = wrap.querySelectorAll(".tab-content");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].classList.remove("active");
    }
    tabbuttons = wrap.querySelectorAll(".tab-button");
    for (i = 0; i < tabbuttons.length; i++) {
      tabbuttons[i].className = tabbuttons[i].className.replace(" active", "");
    }
    wrap.querySelector("#" + tabName).classList.add("active");
    
    evt.currentTarget.className += " active";
  }

function updateGridProductSwatch(swatch) {
  var meta = swatch.closest('.grid-product__meta');
  var content = swatch.closest('.grid-product__content');
  var source = swatch.previousElementSibling;
  if (!meta || !content || !source || !source.classList.contains('info_hidden')) return;

  meta.querySelectorAll('.color-swatch-select-parent').forEach(function (item) {
    item.classList.toggle('selected', item === swatch);
  });

  var sourceLink = source.querySelector('.grid-product__link');
  var sourceImage = source.querySelector('.imag_wrap');
  var sourcePrice = source.querySelector('.cur_p');
  var sourceSaveLabel = source.querySelector('.image-price-label');
  var href = sourceLink ? sourceLink.getAttribute('href') : null;

  if (href) {
    var itemLink = content.querySelector('.grid-product__link.item_link');
    if (itemLink) itemLink.setAttribute('href', href);
    content.querySelectorAll('.btn').forEach(function (button) {
      button.setAttribute('href', href);
    });
  }

  var imageWrap = content.querySelector('.image-wrap.item_img');
  if (imageWrap && sourceImage) imageWrap.innerHTML = sourceImage.innerHTML;

  var saleTag = content.querySelector('.grid-product__tag--sale');
  var salePrice = content.querySelector('.grid-product__price .sale-price');
  var originalPrice = content.querySelector('.grid-product__price .grid-product__price--original');
  if (!saleTag && !salePrice && !originalPrice) return;

  var saveText = sourceSaveLabel ? sourceSaveLabel.textContent.trim() : '';
  if (!saveText) {
    if (saleTag) saleTag.classList.add('hidden');
    if (salePrice) salePrice.classList.add('hidden');
    if (originalPrice) originalPrice.classList.remove('del');
    return;
  }

  if (saleTag) {
    saleTag.classList.remove('hidden');
    saleTag.textContent = saveText;
  }
  if (salePrice && sourcePrice) {
    salePrice.classList.remove('hidden');
    salePrice.textContent = sourcePrice.textContent;
    var productPrice = sourcePrice.getAttribute('data-product-price');
    if (productPrice !== null) salePrice.setAttribute('data-product-price', productPrice);
  }
  if (originalPrice) originalPrice.classList.add('del');
}

document.addEventListener('click', function (event) {
  var swatch = event.target.closest('.grid-product__meta .color-swatch-select-parent');
  if (swatch) updateGridProductSwatch(swatch);
});
/*** end product bundle ***/

function initProduct360Viewer(pane) {
  if (!pane || pane.dataset.viewerInited === 'true') return;

  var viewer = pane.querySelector('[data-product-360-viewer]');
  if (!viewer) return;

  var frames = Array.from(pane.querySelectorAll('.product-media-360-frame'));
  if (!frames.length) return;

  var state = {
    frameCount: frames.length,
    frameIndex: 0,
    startX: 0,
    dragging: false,
    pointerId: null,
    threshold: 12,
    loadPromiseMap: {},
    preloadStarted: false
  };

  function normalizeIndex(index) {
    return ((index % state.frameCount) + state.frameCount) % state.frameCount;
  }

  function markFrameLoaded(index) {
    frames[index].dataset.loaded = 'true';
  }

  function isFrameLoaded(index) {
    return frames[index].dataset.loaded === 'true';
  }

  function activateFrame(index) {
    state.frameIndex = index;
    frames.forEach(function (frame, frameIndex) {
      frame.classList.toggle('is-active', frameIndex === index);
    });
  }

  function loadFrame(index) {
    var normalized = normalizeIndex(index);
    var frame = frames[normalized];

    if (isFrameLoaded(normalized)) {
      return Promise.resolve(normalized);
    }

    if (state.loadPromiseMap[normalized]) {
      return state.loadPromiseMap[normalized];
    }

    var frameSrc = frame.dataset.frameSrc;
    if (!frameSrc) {
      markFrameLoaded(normalized);
      return Promise.resolve(normalized);
    }

    state.loadPromiseMap[normalized] = new Promise(function(resolve) {
      var preloader = new Image();
      preloader.onload = function() {
        frame.src = frameSrc;
        markFrameLoaded(normalized);
        resolve(normalized);
      };
      preloader.onerror = function() {
        resolve(normalized);
      };
      preloader.src = frameSrc;
    }).finally(function() {
      delete state.loadPromiseMap[normalized];
    });

    return state.loadPromiseMap[normalized];
  }

  function runQueue(indices, concurrency) {
    if (!indices.length) return Promise.resolve();

    return new Promise(function(resolve) {
      var cursor = 0;
      var activeCount = 0;

      function pump() {
        while (activeCount < concurrency && cursor < indices.length) {
          var frameIndex = indices[cursor];
          cursor += 1;
          activeCount += 1;

          loadFrame(frameIndex).finally(function() {
            activeCount -= 1;
            if (cursor >= indices.length && activeCount === 0) {
              resolve();
              return;
            }
            pump();
          });
        }
      }

      pump();
    });
  }

  function circularDistance(fromIndex, toIndex) {
    var direct = Math.abs(fromIndex - toIndex);
    return Math.min(direct, state.frameCount - direct);
  }

  function findLoadedFallback(targetIndex, direction) {
    for (var step = 1; step < state.frameCount; step += 1) {
      var candidate = normalizeIndex(targetIndex - direction * step);
      if (isFrameLoaded(candidate)) {
        return candidate;
      }
    }
    return state.frameIndex;
  }

  function startPreload() {
    if (state.preloadStarted || state.frameCount < 2) return;
    state.preloadStarted = true;

    var preloadIndexMap = {};
    for (var i = 0; i < state.frameCount; i += 1) {
      // Even frames are already requested via src in Liquid.
      // Here we prioritize odd frames to complete the sequence quickly.
      if (i % 2 === 0) continue;
      var index = normalizeIndex(i);
      if (index === state.frameIndex) continue;
      preloadIndexMap[index] = true;
    }

    var uniqueTargets = Object.keys(preloadIndexMap).map(function(key) {
      return parseInt(key, 10);
    });
    uniqueTargets.sort(function(a, b) {
      return circularDistance(state.frameIndex, a) - circularDistance(state.frameIndex, b);
    });

    runQueue(uniqueTargets, 4);
  }

  function setFrame(index, direction) {
    var normalized = normalizeIndex(index);
    if (isFrameLoaded(normalized)) {
      activateFrame(normalized);
      return;
    }
    var fallbackIndex = findLoadedFallback(normalized, direction || 1);
    if (fallbackIndex !== state.frameIndex) {
      activateFrame(fallbackIndex);
    }
    loadFrame(normalized).then(function(loadedIndex) {
      activateFrame(loadedIndex);
    });
  }

  function handlePointerMove(event) {
    if (!state.dragging || (state.pointerId !== null && event.pointerId !== state.pointerId)) return;
    if (event.cancelable) event.preventDefault();
    var deltaX = event.clientX - state.startX;
    if (Math.abs(deltaX) < state.threshold) return;

    var steps = Math.floor(Math.abs(deltaX) / state.threshold);
    var direction = deltaX > 0 ? -1 : 1;
    setFrame(state.frameIndex + direction * steps, direction);
    state.startX = event.clientX;
  }

  function handlePointerUp(event) {
    if (state.pointerId !== null && event.pointerId !== state.pointerId) return;
    state.dragging = false;
    viewer.classList.remove('is-dragging');
    if (state.pointerId !== null && viewer.hasPointerCapture && viewer.hasPointerCapture(state.pointerId)) {
      viewer.releasePointerCapture(state.pointerId);
    }
    state.pointerId = null;
  }

  viewer.addEventListener('pointerdown', function(event) {
    startPreload();
    state.dragging = true;
    state.startX = event.clientX;
    state.pointerId = event.pointerId;
    viewer.classList.add('is-dragging');
    if (viewer.setPointerCapture) {
      viewer.setPointerCapture(event.pointerId);
    }
  });

  viewer.addEventListener('pointermove', handlePointerMove);
  viewer.addEventListener('pointerup', handlePointerUp);
  viewer.addEventListener('pointercancel', handlePointerUp);
  viewer.addEventListener('pointerleave', handlePointerUp);

  startPreload();
  pane.dataset.viewerInited = 'true';
}

function getCurrentImageSlideIndex(container) {
  var counter = getImageCounter(container);
  var counterIndex = parseInt(counter ? counter.textContent.trim() : '', 10);
  if (!isNaN(counterIndex) && counterIndex > 0) {
    return counterIndex - 1;
  }

  var activeDot = getMediaDots(container).find(function (dot) {
    return dot.classList.contains('is-primary');
  });
  if (activeDot) {
    var activeDotIndex = parseInt(activeDot.dataset.dotIndex, 10);
    if (!isNaN(activeDotIndex)) {
      return activeDotIndex;
    }
  }

  return 0;
}

function getImageCounter(container) {
  return container ? container.querySelector('.media-counter-current') : null;
}

function getMediaDots(container) {
  return container ? Array.from(container.querySelectorAll('.product-media-carousel_thumbs_wrap [data-carousel-dot], .product-media-carousel-mobile__dots-carousel-container [data-carousel-dot]')) : [];
}

function clearImageRestoreTimer(container) {
  var pendingRestoreTimer = container ? container._imageRestoreTimer : null;
  if (!pendingRestoreTimer) return;
  clearTimeout(pendingRestoreTimer);
  container._imageRestoreTimer = null;
}

function resolveTargetPane(carousel, mode) {
  var resolvedMode = mode;
  var targetPane = carousel.querySelector('[data-media-pane="' + resolvedMode + '"]');
  if (targetPane) {
    return { mode: resolvedMode, pane: targetPane };
  }
  resolvedMode = 'image';
  return {
    mode: resolvedMode,
    pane: carousel.querySelector('[data-media-pane="image"]')
  };
}

function setPaneVisibility(carousel, targetPane) {
  carousel.querySelectorAll('[data-media-pane]').forEach(function (pane) {
    pane.classList.add('hide');
  });
  if (targetPane) targetPane.classList.remove('hide');
}

function setImageControlVisibility(carousel, mode) {
  carousel.querySelectorAll('[data-image-only-control]').forEach(function (control) {
    var shouldHide = mode !== 'image' || control.hasAttribute('data-counter-hidden-control');
    control.classList.toggle('hide', shouldHide);
  });
}

function restoreImageSlideIndex(container, slideIndex) {
  if (typeof slideIndex !== 'number' || slideIndex < 0) return;
  var currentIndex = getCurrentImageSlideIndex(container);
  if (currentIndex === slideIndex) return;
  var allDots = getMediaDots(container);
  var targetIndexText = String(slideIndex);
  var targetDot = allDots.find(function(dot) {
    return (dot.dataset.dotIndex || '') === targetIndexText;
  });
  if (!targetDot && slideIndex === 0) {
    targetDot = allDots[0];
  }
  if (targetDot) {
    targetDot.click();
  }
}

function moveImageToFirstSlide(container) {
  var allDots = getMediaDots(container);
  var firstDot = allDots.find(function(dot) {
    return (dot.dataset.dotIndex || '') === '0';
  });
  if (!firstDot) {
    firstDot = allDots[0];
  }
  if (firstDot) {
    firstDot.click();
  }
  var counter = getImageCounter(container);
  if (counter) counter.textContent = '1';
}

function restoreImageStateOnReturn(container, prevMode) {
  clearImageRestoreTimer(container);
  var restoreTimer = setTimeout(function() {
    if ((container._productMediaMode || '').toString() !== 'image') return;
    if (prevMode === '360' || prevMode === 'video') {
      moveImageToFirstSlide(container);
    } else {
      var savedImageSlideIndex = container._imageSlideIndex;
      if (typeof savedImageSlideIndex !== 'number') return;
      restoreImageSlideIndex(container, savedImageSlideIndex);
    }
    container._imageRestoreTimer = null;
  }, 0);
  container._imageRestoreTimer = restoreTimer;
}

function setProductMediaMode(container, mode) {
  if (!container) return;
  var carousel = container.querySelector('product-media-carousel');
  if (!carousel) return;
  var prevMode = (container._productMediaMode || 'image').toString();

  var target = resolveTargetPane(carousel, mode);
  mode = target.mode;
  var targetPane = target.pane;
  setPaneVisibility(carousel, targetPane);

  if (prevMode === 'image' && mode !== 'image') {
    container._imageSlideIndex = getCurrentImageSlideIndex(container);
  }

  setImageControlVisibility(carousel, mode);
  if (mode === 'image') {
    if (prevMode !== 'image') {
      restoreImageStateOnReturn(container, prevMode);
    }
  } else {
    clearImageRestoreTimer(container);
  }

  if (mode === '360') {
    initProduct360Viewer(targetPane);
  }

  carousel.querySelectorAll('.product-media-video video').forEach(function(video) {
    if (mode !== 'video' && video.pause) {
      video.pause();
    }
  });

  container._productMediaMode = mode;
}

function warmupProduct360Viewers() {
  document.querySelectorAll('div[data-product-media-container] [data-media-pane="360"]').forEach(function(pane) {
    initProduct360Viewer(pane);
  });
}

function scheduleProduct360Warmup() {
  if (window.__pdpMedia360WarmupScheduled) return;
  window.__pdpMedia360WarmupScheduled = true;

  if (window.requestIdleCallback) {
    window.requestIdleCallback(function() {
      warmupProduct360Viewers();
    }, { timeout: 2500 });
    return;
  }

  setTimeout(function() {
    warmupProduct360Viewers();
  }, 1800);
}

function bindProductMediaHandlers() {
  if (window.__productMediaHandlersBound) return;
  window.__productMediaHandlersBound = true;

  document.addEventListener('click', function (event) {
    var thumbnail = event.target.closest('.product-media-carousel_thumbs_wrap .carousel__slide');
    if (thumbnail) {
      var thumbnailContainer = thumbnail.closest('div[data-product-media-container]');
      if (!thumbnailContainer) return;
      setProductMediaMode(thumbnailContainer, 'image');
      var imageButton = thumbnailContainer.querySelector('.pdp-toggle-image_video .toggle-image_video[data-name="image"]');
      if (imageButton && imageButton.parentElement) {
        Array.from(imageButton.parentElement.children).forEach(function (button) {
          button.classList.toggle('active', button === imageButton);
        });
      }
      return;
    }

    var mediaButton = event.target.closest('.pdp-toggle-image_video .toggle-image_video');
    if (!mediaButton) return;
    var mode = (mediaButton.dataset.name || '').toString();
    var mediaContainer = mediaButton.closest('div[data-product-media-container]');
    if (mediaButton.parentElement) {
      Array.from(mediaButton.parentElement.children).forEach(function (button) {
        button.classList.toggle('active', button === mediaButton);
      });
    }
    setProductMediaMode(mediaContainer, mode);
  });
}

scheduleProduct360Warmup();
bindProductMediaHandlers();


// document.addEventListener('change', function(event) {
//   if (event.target.matches('.product-form.multiple-variants .cart-drawer-related__variant')) {
//     var selectElement = event.target;
//     var selectedValue = selectElement.value;
//     // console.log('select:', selectedValue);
    
//     var form = selectElement.closest('form');
//     var idInput = form.querySelector('input[name="id"]');
//     idInput.value = selectedValue;
//     document.querySelector(".cart-drawer").classList.remove('is-cart-loading');
//   }
// });

/*** call us ***/
function updateCartNote(){
  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ note: "clickedcallus" })
  })
  .then(response => response.json())
  .then(data => {
    // console.log('Order note updated:', data);
  })
  .catch(error => {
    console.error('Failed to update order note:', error);
  });
}
const callUsIcon = document.querySelector('.call-us-icon');
const callIcon = document.querySelector('.call-icon');
const closeIcon = document.querySelector('.call_us_close');
const closeIconSvg = document.querySelector('.call_us_close_icon')
const callUsDetails = document.querySelector('.call-us-details');

if (callUsIcon) {
  callUsIcon.addEventListener('click', () => {
    const isHidden = callUsDetails.classList.toggle('custom_hidden');
    
    callIcon.classList.toggle('custom_hidden', !isHidden);
    closeIcon.classList.toggle('custom_hidden', isHidden);
    closeIconSvg.classList.toggle('active', !isHidden);
    callUsIcon.classList.toggle('active');
    localStorage.setItem('called_us', 'true');
    updateCartNote()
  });
}

function openPhone(){
  window.location.href = "tel:+18885593099";
  localStorage.setItem('called_us', 'true');
  updateCartNote()
}
const calledUs = window.localStorage.getItem('called_us') === 'true';
if(calledUs){
  updateCartNote()
}

// document.querySelectorAll('.smooth-scroll').forEach(link => {
//   link.addEventListener('click', function(e) {
//     e.preventDefault();
//     const targetId = this.getAttribute('href')?.substring(1);
//     if (!targetId) return;

//     const target = document.getElementById(targetId);
//     if (!target) return;

//     const offset = Number(this.dataset.position) || 0;
//     const y = target.getBoundingClientRect().top + window.scrollY - offset;

//     window.scrollTo({
//       top: y,
//       behavior: 'smooth'
//     });
//   });
// });
// N2 geometry
// var toggleSwitch = document.getElementById('toggleSwitch');
// if (toggleSwitch) {
//   toggleSwitch.addEventListener('change', function () {
//     var stepThruContent = document.getElementById('stepThruContent');
//     var highStepContent = document.getElementById('highStepContent');
//     if (this.checked) {
//       stepThruContent.style.display = 'none';
//       highStepContent.style.display = 'block';
//     } else {
//       stepThruContent.style.display = 'block';
//       highStepContent.style.display = 'none';
//     }
//   });
// }

document.addEventListener('submit', function(event) {
  if (typeof window.dataLayer === 'undefined') {
    return;
  }
  const form = event.target;
  // login
  if (form.id === 'customer_login') {
    window.dataLayer.push({
      "event": "login",
      "method": "email"
    });
  }
  // register
  if (form.id === 'create_customer') {
    window.dataLayer.push({
      "event": "sign_up",
      "method": "email"
    });
  }
}, true);

function handleProductVariantChange(e, capturedVariantId) {
  const variantInput = e.target.closest(
    '.product input[data-product-form-variant]'
  );
  if (!variantInput) return;

  const variantId = Number(capturedVariantId || variantInput.getAttribute('value') || variantInput.value);
  const variant = window.productVariants?.find(v => v.id === variantId);
  if (!variant) return;

  const productContent = variantInput.closest('product-content') || variantInput.closest('.shopify-section') || document;
  const productId = productContent.querySelector('variant-picker')?.dataset.productId;
  const compareAtPrice = Number(variant.compare_at_price) || 0;
  const price = Number(variant.price) || 0;

  window.requestAnimationFrame(function() {
    productContent.querySelectorAll(`[data-image-price-label][data-product-id="${productId}"]`).forEach(function(label) {
      const freeItemValue = Number(label.dataset.freeItemValue) || 0;
      const savedAmount = Math.max(compareAtPrice - price, 0) + freeItemValue;

      label.hidden = savedAmount <= 0;
      if (savedAmount > 0) {
        label.textContent = `Save $${(savedAmount / 100).toLocaleString('en-US', { maximumFractionDigits: 2 })}`;
      }
    });
  });

  const stickyRoot = document.querySelector('.sticky-atc__inner');
  if (!stickyRoot) return;

  /* 图片 */
  if (variant.featured_image?.src) {
    const img = stickyRoot.querySelector('.sticky-atc__image img');
    img && (img.src = `${variant.featured_image.src}&width=64`);
  }

  /* 基础价（分） */
  const priceEl = stickyRoot.querySelector('[data-sticky-price]');
  if (priceEl) {
    priceEl.dataset.price = variant.price;
  }

  // 捆绑bundle
  if (variant.name.includes("Velotric T1 ST Plus Ebike")) {
    const bundleCard = document.querySelector(
      '.bundle-container product-card[data-id="7306271326391"]'
    );
    if (bundleCard) {
      const select = bundleCard.querySelector('select');
      if (select) {
        const targetValue = variant.option1 === "Large"
          ? "41772836257975"
          : "41772836225207";

        if (select.querySelector(`option[value="${targetValue}"]`)) {
          select.value = targetValue;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }
  }
  // gomad
  if (variant.name.includes("Velotric GoMad Ebike")) {
    const titleEl = stickyRoot.querySelector('.sticky-atc__title-name');
    titleEl.textContent = variant.options[0];
  }

  updateStickyAtcPrice();
}

document.addEventListener('change', handleProductVariantChange);

const mobileVariantFeaturedMediaEarlyState = window.__mobileVariantFeaturedMediaEarlyState;
if (mobileVariantFeaturedMediaEarlyState) {
  const missedVariantInput = mobileVariantFeaturedMediaEarlyState.lastVariantInput;
  const missedVariantId = mobileVariantFeaturedMediaEarlyState.lastVariantId;

  mobileVariantFeaturedMediaEarlyState.ready = true;
  mobileVariantFeaturedMediaEarlyState.lastVariantInput = null;
  mobileVariantFeaturedMediaEarlyState.lastVariantId = null;

  if (missedVariantInput?.isConnected) {
    handleProductVariantChange({ target: missedVariantInput }, missedVariantId);
  }
}

document.addEventListener('DOMContentLoaded', function() {
  if (typeof window.dataLayer === 'undefined') {
    return;
  }
  // newsletter
  const subscribeForms = document.querySelectorAll('.newsletter__form');
  if (subscribeForms.length) {
    subscribeForms.forEach(function(form) {
      const subscribeButton = form.querySelector('button[name="commit"]');
      if (subscribeButton) {
        subscribeButton.addEventListener('click', function() {
          window.dataLayer.push({
            "event": "newsletter_subscription"
          });
        });
      }
    });
  }
});


(function () {

  const App = {

    /* =========================
     * Init
     * ========================= */
    init(scope = document) {
      this.initYoutubeReview(scope);
    },
    /* Popup */
    popup: {
      lastTrigger: null,
      focusableSelector: 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',

      getContent(content, name) {
        return (
          POPUP_CONTENT_BY_PAIR[`${content}|${name}`] ||
          POPUP_CONTENT_BY_NAME[name] ||
          POPUP_CONTENT_BY_CONTENT[content] ||
          ""
        );
      },

      open({ content, name, trigger }) {
        this.lastTrigger = trigger || document.activeElement;
        if (
          this.lastTrigger &&
          this.lastTrigger !== document.body &&
          !this.lastTrigger.matches(this.focusableSelector) &&
          !this.lastTrigger.hasAttribute("tabindex")
        ) {
          this.lastTrigger.setAttribute("tabindex", "-1");
          this.lastTrigger.dataset.popupRestoreTabindex = "true";
        }
        const root = document.querySelector("#custom_popup");
        if (!root) return;

        const popup = root.querySelector(".popup");
        const contentEl = root.querySelector(".popup__content");

        if (popup) {
          popup.classList.remove("n2x", "n2x_large");
          if (POPUP_CLASS_BY_NAME[name]) {
            popup.classList.add(POPUP_CLASS_BY_NAME[name]);
          }
        }

        if (contentEl) {
          contentEl.innerHTML = this.getContent(content, name);
        }

        if (content === "compare") {
          this.handleCompare(name);
          const comparePopup = document.querySelector("#compare_popup");
          comparePopup?.classList.add("active");
          this.openDialog(comparePopup);
          return;
        }

        root.classList.add("active");
        this.openDialog(root);
      },

      close() {
        const customPopup = document.querySelector("#custom_popup");
        customPopup?.classList.remove("active");
        customPopup?.setAttribute("aria-hidden", "true");
        const comparePopup = document.querySelector("#compare_popup");
        comparePopup?.classList.remove("active");
        comparePopup?.setAttribute("aria-hidden", "true");
        document.querySelectorAll(".custom-popup-group").forEach((el) => {
          el.classList.remove("active");
        });
        if (this.lastTrigger && document.contains(this.lastTrigger)) {
          this.lastTrigger.focus();
          if (this.lastTrigger.dataset.popupRestoreTabindex === "true") {
            this.lastTrigger.removeAttribute("tabindex");
            delete this.lastTrigger.dataset.popupRestoreTabindex;
          }
        }
      },
      openDialog(root) {
        if (!root) return;

        root.setAttribute("aria-hidden", "false");

        const dialog = root.querySelector('[role="dialog"]');
        const focusTarget = root.querySelector(".popup__close-button") || dialog;

        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            focusTarget?.focus();
          });
        });
      },

      trapFocus(root, event) {
        const focusable = Array.from(root.querySelectorAll(this.focusableSelector))
          .filter((element) => element.offsetParent !== null || element === document.activeElement);

        if (!focusable.length) {
          event.preventDefault();
          root.querySelector('[role="dialog"]')?.focus();
          return;
        }

        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      },
      handleCompare(name) {
        const manager = document.querySelector('#compare_popup vl-product-compare-manager');
        manager?.activatePdp();
      }
    },
    initAccordion() {
      // 不需要做任何初始化，占位用
    },
    /* =========================
     * YouTube Review（懒加载版）
     * ========================= */
    initYoutubeReview(scope = document) {

      scope.querySelectorAll('.youtube-review-section').forEach(section => {
        if (section.dataset.init) return;
        section.dataset.init = 'true';

        const tabBtns = section.querySelectorAll('.review-tab-btn');
        const tabContents = section.querySelectorAll('.review-tab-content');

        const carousels = {};

        const refreshCarousel = (tabKey) => {
          if (carousels[tabKey]) {
            carousels[tabKey].refresh?.({ emit: false, preserveIndex: true });
            return;
          }

          const content = section.querySelector(`.review-tab-content[data-tab="${tabKey}"]`);
          if (!content) return;

          const container = content.querySelector(`.review-carousel-${tabKey}`);
          if (!container) return;

          container.refresh?.({ emit: false, preserveIndex: true });
          carousels[tabKey] = container;
        };

        /* ===== 初始：只初始化 active ===== */
        const activeContent = section.querySelector('.review-tab-content.active');
        if (activeContent) {
          refreshCarousel(activeContent.dataset.tab);
        }

        /* ===== Tab 切换 ===== */
        tabBtns.forEach(btn => {
          btn.addEventListener('click', () => {

            const target = btn.dataset.tab;

            tabBtns.forEach(b => b.classList.remove('active'));
            btn.classList.add('active');

            tabContents.forEach(content => {
              content.classList.remove('active');

              if (content.dataset.tab === target) {
                content.classList.add('active');

                // 懒初始化关键
            refreshCarousel(target);
              }
            });

          });
        });

        /* ===== Modal video ===== */
        const modal = section.querySelector('.video-modal');
        const closeBtn = section.querySelector('.close-modal');
        const iframe = section.querySelector('#youtubeVideo');

        if (modal && closeBtn && iframe) {
          const buildYoutubeSrc = (youtubeId, autoplay) => {
            const safeId = (youtubeId || '').trim();
            if (!safeId) return '';
            return `https://www.youtube.com/embed/${safeId}?autoplay=${autoplay ? 1 : 0}&rel=0`;
          };

          const openModal = (youtubeId) => {
            const nextSrc = buildYoutubeSrc(youtubeId, true);
            if (!nextSrc) return;

            iframe.src = nextSrc;
            modal.classList.add('active');
          };

          const closeModal = () => {
            modal.classList.remove('active');
            iframe.src = '';
          };

          section.querySelectorAll('.reviewBox[data-yid]').forEach(reviewBox => {
            reviewBox.addEventListener('click', () => {
              openModal(reviewBox.dataset.yid);
            });
          });

          closeBtn.addEventListener('click', closeModal);
          modal.addEventListener('click', (e) => {
            if (e.target === modal) {
              closeModal();
            }
          });

          document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && modal.classList.contains('active')) {
              closeModal();
            }
          });
        }

      });

    },

  };

  /* =========================================
   * 全局事件委托（统一管理）
   * ========================================= */

  document.addEventListener('click', function (e) {

    /* smooth scroll */
    const scrollLink = e.target.closest('.smooth-scroll');
    if (scrollLink) {
      e.preventDefault();

      // const id = scrollLink.getAttribute('href')?.substring(1);
      // const target = document.getElementById(id);
      // if (!target) return;
      const id = scrollLink.getAttribute('href')?.substring(1);
      if (!id) return;

      const isUserStoryPage = !!scrollLink.closest('#user-story-2');
      const isMobileViewport = window.matchMedia('(max-width: 768px)').matches;
      let target = null;

      if (isUserStoryPage && isMobileViewport) {
        const mobileTargets = Array.from(document.querySelectorAll(`[data-nav-anchor="${id}"]`));
        target = mobileTargets.find((item) => item.getClientRects().length > 0) || mobileTargets[0] || null;
      }

      if (!target) {
        target = document.getElementById(id);
      }

      if (!target) return;

      const offset = Number(scrollLink.dataset.position) || 0;

      window.scrollTo({
        top: target.getBoundingClientRect().top + window.scrollY - offset,
        behavior: 'smooth'
      });
    }

    /* =========================
    * Accordion（通用）
    * <div class="accordion">
        <div class="panel">
          <div class="panel-header">Title</div>
          <div class="panel-body">Content</div>
        </div>
      </div>
    * ========================= */

    /* learn more */
    const learnMoreBtn = e.target.closest('.accordion .learn-more');

    if (learnMoreBtn) {
      e.preventDefault();
      e.stopPropagation();

      const body = learnMoreBtn.closest('.panel-body');

      if (!body) return;

      if (body.classList.contains('expanded')) {
        body.classList.remove('expanded');
        learnMoreBtn.textContent = 'Show More';
      } else {
        body.classList.add('expanded');
        learnMoreBtn.textContent = 'Show Less';
      }

      return;
    }


    /* panel toggle */
    const header = e.target.closest('.accordion .panel-header');

    if (header) {

      const panel = header.closest('.panel');
      const container = header.closest('.accordion');
      const body = panel.querySelector('.panel-body');

      if (!panel || !body) return;

      const isOpen = panel.classList.contains('open');

      /* 是否单开（可配置） */
      const isSingle = container.dataset.accordion !== 'multi';

      if (isOpen) {
        slideUp(body);
        panel.classList.remove('open');
      } else {

        if (isSingle) {
          container.querySelectorAll('.panel.open').forEach(p => {
            p.classList.remove('open');
            slideUp(p.querySelector('.panel-body'));
          });
        }

        panel.classList.add('open');
        slideDown(body);
      }
    }

    /* =========================
    * PDP Media Switcher（可扩展）
    * ========================= */

    // const mediaToggle = e.target.closest('.pdp-toggle-image_video .toggle-image_video');

    // if (mediaToggle) {

    //   const mediaType = mediaToggle.dataset.media;

    //   /* 1️⃣ 按钮状态 */
    //   const btnGroup = mediaToggle.parentElement;

    //   btnGroup.querySelectorAll('.toggle-image_video')
    //     .forEach(btn => btn.classList.remove('active'));

    //   mediaToggle.classList.add('active');

    //   /* 2️⃣ 找容器 */
    //   const container = mediaToggle.closest('[data-product-media-container]');
    //   if (!container) return;

    //   /* 3️⃣ 切换所有 media */
    //   container.querySelectorAll('[data-name]').forEach(el => {

    //     if (el.dataset.media === mediaType) {
    //       el.classList.remove('hide');
    //     } else {
    //       el.classList.add('hide');

    //       /* 👉 如果是 video，顺手暂停 */
    //       const video = el.querySelector('video');
    //       if (video) {
    //         video.pause();
    //         video.currentTime = 0;
    //       }
    //     }

    //   });

    //   return;
    // }
    // const thumbSlide = e.target.closest('.product-media-carousel_thumbs_wrap .carousel__slide');

    // if (thumbSlide) {

    //   const container = thumbSlide.closest('[data-product-media-container]');
    //   if (!container) return;

    //   /* 找 image 按钮 */
    //   const imageBtn = container.querySelector('.toggle-image_video[data-name="image"]');

    //   if (imageBtn) {
    //     imageBtn.click(); // 👈 复用逻辑（关键！）
    //   }

    //   return;
    // }

    /* pdp popup open */
    const popupTrigger = e.target.closest('[data-popup]');
    if (popupTrigger) {
      e.preventDefault();

      App.popup.open({
        content: popupTrigger.dataset.popup,
        name: popupTrigger.dataset.popupName,
        trigger: popupTrigger
      });

      return;
    }

    /* pdp popup close */
    const popupClose = e.target.closest('.popup__close-button, [data-close-btn], [data-close-small-btn]');
    if (popupClose) {
      App.popup.close();
      return;
    }

    /* click overlay close */
    const popupOverlay = e.target.closest('.custom-popup-group .popup, .popup.popup-promo, #custom_popup .popup');
    if (popupOverlay && !e.target.closest('.popup__content')) {
      App.popup.close();
    }
    

  });
  /* hover tab（header / mega menu 用） */
  document.addEventListener('keydown', function (e) {
    const activePopup = document.querySelector('#custom_popup.active, #compare_popup.active');
    if (!activePopup) return;

    if (e.key === 'Escape' || e.key === 'Esc') {
      e.preventDefault();
      const nestedDialog = activePopup.querySelector('dialog[open]');
      if (nestedDialog) {
        nestedDialog.close();
        return;
      }
      App.popup.close();
      return;
    }

    if (e.key === 'Tab') {
      App.popup.trapFocus(activePopup, e);
    }
  }, true);
  document.addEventListener('mouseover', function (e) {

    const tabBtn = e.target.closest('[data-tab-trigger="hover"]');
    if (!tabBtn) return;

    const containerSelector = tabBtn.dataset.tabContainer;
    const targetId = tabBtn.dataset.tabTarget;

    const container = document.querySelector(containerSelector);
    if (!container) return;

    /* 防抖：避免重复触发 */
    if (tabBtn.classList.contains('active')) return;

    /* 按钮 active */
    container.querySelectorAll('.bike-nav-tab-item')
      .forEach(el => el.classList.remove('active'));

    tabBtn.classList.add('active');

    /* 内容切换 */
    container.querySelectorAll('.bike-nav-tab_wrap')
      .forEach(el => el.classList.remove('active'));

    const target = document.getElementById(targetId);
    if (target) target.classList.add('active');

  });
  document.addEventListener('change', function (e) {

    /* =========================
   * Cart Drawer Variant Sync
   * ========================= */
    const variantSelect = e.target.closest(
      '.product-form.multiple-variants .cart-drawer-related__variant'
    );

    if (variantSelect) {

      const form = variantSelect.closest('form');
      if (!form) return;

      const idInput = form.querySelector('input[name="id"]');
      if (!idInput) return;

      /* 同步 variant */
      idInput.value = variantSelect.value;

      /* 状态恢复 */
      const cartDrawer = document.querySelector('.cart-drawer');
      if (cartDrawer) {
        cartDrawer.classList.remove('is-cart-loading');
      }

      return;
    }

    /* toggleSwitch */
    if (e.target.id === 'toggleSwitch') {
      const step = document.getElementById('stepThruContent');
      const high = document.getElementById('highStepContent');

      if (!step || !high) return;

      step.style.display = e.target.checked ? 'none' : 'block';
      high.style.display = e.target.checked ? 'block' : 'none';
    }

  });

  /* =========================================
   * 生命周期控制（关键）
   * ========================================= */

  // 初始执行（静态 DOM）
  App.init();

  // Shopify section 动态加载
  document.addEventListener('shopify:section:load', function (e) {
    App.init(e.target);
  });

  // DOM 变化兜底（Rebuy / Ajax）
  const observer = new MutationObserver(() => {
    App.init();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  /* 暴露给全局（兼容旧代码） */
  // function initHeaderA11yMenus() {
  //   const desktopQuery = window.matchMedia('(min-width: 1200px)');
  //   const triggerSelector = '[data-header-a11y-menu-trigger]';
  //   const focusableSelector = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';
  //   let activeTrigger = null;

  //   function isDesktop() {
  //     return desktopQuery.matches;
  //   }

  //   function getTriggerHost(trigger) {
  //     return trigger.closest('float-element-btn, header-float-element-btn, dropdown-opener');
  //   }

  //   function getMenu(trigger) {
  //     return document.getElementById(trigger.dataset.headerA11yMenuId);
  //   }

  //   function getMenuPanel(trigger) {
  //     const menu = getMenu(trigger);
  //     if (!menu) return null;

  //     const templateId = trigger.dataset.headerA11yTemplateId;
  //     if (templateId) {
  //       return menu.querySelector('[data-header-float-element-template="' + templateId + '"]') || menu;
  //     }

  //     return menu;
  //   }

  //   function getFirstMenuTarget(trigger) {
  //     const panel = getMenuPanel(trigger);
  //     if (!panel) return null;

  //     return Array.from(panel.querySelectorAll(focusableSelector)).find(function (target) {
  //       return target.offsetParent !== null || target.getClientRects().length > 0;
  //     });
  //   }

  //   function setTriggerExpanded(trigger, isExpanded) {
  //     const host = getTriggerHost(trigger);

  //     trigger.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
  //     if (host) {
  //       host.setAttribute('data-aria-expanded', isExpanded ? 'true' : 'false');
  //     }
  //   }

  //   function closeMenu(trigger, returnFocus) {
  //     if (!trigger) return;

  //     const menu = getMenu(trigger);
  //     const host = getTriggerHost(trigger);

  //     if (menu && typeof menu.hide === 'function') {
  //       menu.hide();
  //     }

  //     if (trigger.dataset.headerA11yMenuId === 'HeaderDropdownMenu') {
  //       const header = document.querySelector('header-component');
  //       if (header && typeof header.handleMouseLeave === 'function') {
  //         header.handleMouseLeave();
  //       }
  //     }

  //     setTriggerExpanded(trigger, false);

  //     if (host && typeof host.setExpand === 'function') {
  //       host.setExpand(false);
  //     }

  //     if (activeTrigger === trigger) {
  //       activeTrigger = null;
  //     }

  //     if (returnFocus) {
  //       trigger.focus();
  //     }
  //   }

  //   function closeOtherMenus(trigger) {
  //     document.querySelectorAll(triggerSelector + '[aria-expanded="true"]').forEach(function (item) {
  //       if (item !== trigger) closeMenu(item, false);
  //     });
  //   }

  //   function openMenu(trigger, moveFocus) {
  //     const menu = getMenu(trigger);
  //     const host = getTriggerHost(trigger);
  //     const header = document.querySelector('header-component');

  //     if (!menu) return;

  //     closeOtherMenus(trigger);

  //     if (trigger.dataset.headerA11yMenuId === 'HeaderDropdownMenu') {
  //       if (header && typeof header.handleButtonHover === 'function' && host) {
  //         header.handleButtonHover(host);
  //       } else if (typeof menu.show === 'function') {
  //         menu.show();
  //       }
  //     } else if (typeof menu.show === 'function') {
  //       menu.show();
  //     }

  //     setTriggerExpanded(trigger, true);

  //     if (host && typeof host.setExpand === 'function') {
  //       host.setExpand(true);
  //     }

  //     activeTrigger = trigger;

  //     if (moveFocus) {
  //       window.setTimeout(function () {
  //         const firstTarget = getFirstMenuTarget(trigger);
  //         if (firstTarget) firstTarget.focus();
  //       }, 60);
  //     }
  //   }

  //   function toggleMenu(trigger, moveFocus) {
  //     const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
  //     isExpanded ? closeMenu(trigger, false) : openMenu(trigger, moveFocus);
  //   }

  //   if (window.headerA11yMenusInitialized) return;
  //   window.headerA11yMenusInitialized = true;

  //   document.addEventListener('click', function (event) {
  //     const trigger = event.target.closest(triggerSelector);

  //     if (trigger && isDesktop()) {
  //       event.preventDefault();
  //       event.stopImmediatePropagation();
  //       const shouldMoveFocus = event.detail === 0;
  //       toggleMenu(trigger, shouldMoveFocus);
  //       return;
  //     }

  //     if (!activeTrigger) return;

  //     const activeMenu = getMenu(activeTrigger);
  //     const clickedInsideMenu = activeMenu && activeMenu.contains(event.target);
  //     const clickedInsideTrigger = activeTrigger.contains(event.target);

  //     if (!clickedInsideMenu && !clickedInsideTrigger) {
  //       closeMenu(activeTrigger, false);
  //     }
  //   }, true);

  //   document.addEventListener('keydown', function (event) {
  //     const trigger = event.target.closest(triggerSelector);

  //     if (trigger && isDesktop()) {
  //       if (event.key === 'Enter' || event.key === ' ') {
  //         event.preventDefault();
  //         event.stopImmediatePropagation();
  //         toggleMenu(trigger, true);
  //         return;
  //       }

  //       if (event.key === 'Escape' || event.key === 'Esc') {
  //         event.preventDefault();
  //         closeMenu(trigger, true);
  //         return;
  //       }
  //     }

  //     if ((event.key === 'Escape' || event.key === 'Esc') && activeTrigger) {
  //       const activeMenu = getMenu(activeTrigger);

  //       if (activeMenu && activeMenu.contains(event.target)) {
  //         event.preventDefault();
  //         closeMenu(activeTrigger, true);
  //       }
  //     }
  //   }, true);

  //   document.addEventListener('focusin', function (event) {
  //     if (!activeTrigger || !isDesktop()) return;

  //     const activeMenu = getMenu(activeTrigger);
  //     const focusedInsideMenu = activeMenu && activeMenu.contains(event.target);
  //     const focusedInsideTrigger = activeTrigger.contains(event.target);
  //     const focusedAnotherTrigger = event.target.closest(triggerSelector);

  //     if (focusedAnotherTrigger && focusedAnotherTrigger !== activeTrigger) {
  //       closeMenu(activeTrigger, false);
  //       return;
  //     }

  //     if (!focusedInsideMenu && !focusedInsideTrigger) {
  //       closeMenu(activeTrigger, false);
  //     }
  //   });
  // }

  // initHeaderA11yMenus();

  window.VelotricApp = App;

})();

/* TEMP DISABLED: Re-sync the dynamic sticky header when a background tab becomes active again.
// Browsers can pause scroll/debounce callbacks and CSS transitions in hidden tabs,
// leaving the header's sticky + transform state out of sync with the real scroll position.
(function () {
  var restoreScheduled = false;
  var wasHidden = document.hidden;

  function restoreDynamicHeaderPosition() {
    restoreScheduled = false;

    var header = document.querySelector('header-component');
    var section = document.querySelector('.shopify-section-header');
    if (!header || !section) return;

    // Drop any stale compositor transform while the authoritative CSS state is rebuilt.
    var previousTransition = section.style.transition;
    section.style.transition = 'none';
    section.style.transform = 'none';
    void section.offsetHeight;

    // Re-run the component's own responsive setup so its internal thresholds and
    // sticky attributes are recalculated, not just the visible .scrolled class.
    if (typeof header.handleResize === 'function') {
      header.handleResize();
    } else {
      if (typeof header.updatePosition === 'function') header.updatePosition();
      if (typeof header.setScrollStatus === 'function') header.setScrollStatus();
    }

    // handleResize is debounced by the theme, so wait for it before the final sync.
    window.setTimeout(function () {
      if (!header.isConnected || !section.isConnected) return;
      if (typeof header.updatePosition === 'function') header.updatePosition();
      if (typeof header.setScrollStatus === 'function') header.setScrollStatus();
      if ('lastScrollPosition' in header) header.lastScrollPosition = window.scrollY || 0;

      window.requestAnimationFrame(function () {
        // CSS classes/attributes own transform; reveal their freshly calculated value.
        section.style.removeProperty('transform');
        section.style.transition = previousTransition;
      });
    }, 180);
  }

  function scheduleRestore() {
    if (restoreScheduled) return;
    restoreScheduled = true;
    window.requestAnimationFrame(restoreDynamicHeaderPosition);
  }

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      wasHidden = true;
      return;
    }
    if (wasHidden) {
      wasHidden = false;
      scheduleRestore();
    }
  });
  window.addEventListener('pageshow', function (event) {
    // A normal internal navigation also fires pageshow; only BFCache restoration
    // needs the header repair.
    if (event.persisted) scheduleRestore();
  });
  window.addEventListener('focus', function () {
    // visibilitychange normally handles tab/app restoration. Keep focus as a
    // fallback only when the document was previously observed as hidden.
    if (!document.hidden && wasHidden) {
      wasHidden = false;
      scheduleRestore();
    }
  });
})(); */

// PDP media A/B test controller.
(function () {
  function isEnabled() {
    return Boolean(document.querySelector('[data-pdp-media-experiment]'));
  }

  function setVariant(variant) {
    var normalizedVariant = variant === 'b' ? 'b' : 'a';
    window.__pdpMediaExperimentVariant = normalizedVariant;
    if (window.VLAbTest && typeof window.VLAbTest.setPtGroup === 'function') {
      return window.VLAbTest.setPtGroup(normalizedVariant);
    }
    window.__VL_ABTEST_GROUP__ = normalizedVariant;
    return normalizedVariant;
  }

  function getVariant() {
    var group = window.VLAbTest && typeof window.VLAbTest.getGroup === 'function'
      ? window.VLAbTest.getGroup()
      : window.__pdpMediaExperimentVariant;
    return group === 'b' ? 'b' : 'a';
  }

  function dispatchLegacyChange(event) {
    var variant = event && event.detail && event.detail.group
      ? event.detail.group
      : getVariant();
    window.__pdpMediaExperimentVariant = variant;
    document.dispatchEvent(new CustomEvent('pdp-media-experiment-change', {
      detail: { variant: variant }
    }));
    if (isEnabled()) {
      document.dispatchEvent(new CustomEvent('pdp-media-experiment-enable', {
        detail: { variant: variant }
      }));
    }
  }

  window.PdpMediaExperiment = {
    enable: function (variant) {
      return setVariant(variant);
    },
    setVariant: setVariant,
    isEnabled: isEnabled,
    getVariant: getVariant
  };

  document.addEventListener('vl-abtest:change', dispatchLegacyChange);
  if (window.VLAbTest && typeof window.VLAbTest.getGroup === 'function' && window.VLAbTest.getGroup()) {
    dispatchLegacyChange({ detail: { group: window.VLAbTest.getGroup() } });
  }
})();

// PDP media A/B test analytics.
(function () {
  function deviceType() {
    return window.matchMedia('(max-width: 767px)').matches ? 'mobile' : 'desktop';
  }

  function mediaSlide(element) {
    return element.closest('.carousel__slide[data-media-id], .product-media-grid__item[data-media-id]');
  }

  function mediaType(element) {
    var typedElement = element.closest('[data-media-type]');
    if (typedElement && typedElement.dataset.mediaType) return typedElement.dataset.mediaType;

    var slide = mediaSlide(element) || element;
    if (slide.querySelector('vl-video')) return 'video';
    if (slide.querySelector('product-model')) return 'model';
    if (slide.querySelector('deferred-media')) return 'external_video';
    return 'image';
  }

  function mediaIndex(element) {
    var slide = mediaSlide(element);
    if (!slide) return null;
    var container = slide.closest('[data-container="carousel"], [data-container="grid"]');
    var slides = container ? Array.prototype.filter.call(container.children, function (item) {
      return item.hasAttribute('data-media-id');
    }) : [];
    var index = Array.prototype.indexOf.call(slides, slide);
    return index > -1 ? index + 1 : null;
  }

  function selectedVariantId(element) {
    var productContent = element.closest('product-content') || document.querySelector('product-content.product--page');
    var picker = productContent ? productContent.querySelector('variant-picker') : null;
    var formInput = productContent ? productContent.querySelector('input[data-product-form-variant][name="id"]') : null;

    if (picker && picker.variant && picker.variant.id) return String(picker.variant.id);
    return formInput ? formInput.value : null;
  }

  function trackPdpMedia(eventName, element, extra) {
    var experiment = element.closest('[data-experiment-variant]');
    var experimentVariant = experiment
      ? experiment.dataset.experimentVariant
      : element.dataset.experimentVariant;
    if (!window.PdpMediaExperiment || !window.PdpMediaExperiment.isEnabled() || !experimentVariant) return false;
    var mediaContainer = element.closest('[data-product-media-container]');
    var eventParams = {
      experiment_variant: experimentVariant,
      product_id: mediaContainer ? mediaContainer.dataset.productId : element.dataset.productId || null,
      product_variant_id: selectedVariantId(element),
      media_index: mediaIndex(element) || Number(element.dataset.mediaIndex) || null,
      media_type: mediaType(element),
      device_type: deviceType()
    };

    Object.assign(eventParams, extra || {});
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () {
      window.dataLayer.push(arguments);
    };
    window.gtag('event', eventName, eventParams);
    return true;
  }

  function preparePoiModalPortal(event) {
    var poiTrigger = event.target.closest('.product-media-poi__trigger');
    if (!poiTrigger) return;

    var modal = document.querySelector(poiTrigger.dataset.modal);
    if (!modal) return;

    var experiment = poiTrigger.closest('[data-experiment-variant]');
    if (experiment) modal.dataset.experimentVariant = experiment.dataset.experimentVariant;
    modal.dataset.mediaIndex = mediaIndex(poiTrigger);
    modal.dataset.mediaType = poiTrigger.dataset.mediaType;
    delete modal.dataset.closeTracked;

    if (modal.parentElement !== document.body) document.body.appendChild(modal);
  }

  function handlePdpMediaClick(event) {
    var expandButton = event.target.closest('product-modal-button[data-action="open"]');
    if (expandButton) {
      var expandSlide = mediaSlide(expandButton);
      trackPdpMedia('pdp_media_expand', expandButton, {
        entry_media_id: expandButton.dataset.mediaId || (expandSlide ? expandSlide.dataset.mediaId : null),
        entry_media_type: mediaType(expandButton)
      });
    }

    var poiTrigger = event.target.closest('.product-media-poi__trigger');
    if (poiTrigger) {
      trackPdpMedia('pdp_poi_click', poiTrigger, {
        poi_key: poiTrigger.dataset.poiKey,
        poi_label: poiTrigger.dataset.poiLabel
      });
    }

    var playButton = event.target.closest('[data-vl-video-play]');
    if (!playButton) return;
    var video = playButton.closest('vl-video');
    if (video) video.dataset.userInitiatedPlay = 'true';
  }

  function handlePdpMediaKeydown(event) {
    if (event.key !== ' ') return;
    var modalButton = event.target.closest('.product-media-poi__trigger, .product-media-poi-modal__close');
    if (!modalButton) return;
    event.preventDefault();
    modalButton.click();
  }

  function trackPoiModalClose(modal) {
    if (!modal || modal.dataset.closeTracked === 'true') return;
    modal.dataset.closeTracked = 'true';
    trackPdpMedia('pdp_poi_modal_close', modal, {
      poi_key: modal.dataset.poiKey,
      poi_label: modal.dataset.poiLabel
    });
  }

  function initializePoiModalTracking(mainContent) {
    mainContent.querySelectorAll('.product-media-poi-modal').forEach(function (modal) {
      if (modal.dataset.poiTrackingInitialized === 'true' || typeof modal.on !== 'function') return;
      modal.dataset.poiTrackingInitialized = 'true';

      modal.on('show', function () {
        delete modal.dataset.closeTracked;
      });
      modal.on('hide', function () {
        trackPoiModalClose(modal);
      });
      modal.addEventListener('click', function (event) {
        if (event.target === modal && modal.isOpen) modal.hide();
      });
      modal.addEventListener('keydown', handlePdpMediaKeydown);
    });
  }

  function handlePdpVideoPlay(event) {
    var video = event.target;
    var owner = video.closest('vl-video');
    if (!owner) return;

    if (!owner.dataset.progressListenerAttached) {
      owner.dataset.progressListenerAttached = 'true';
      var thresholds = [25, 50, 75, 100];
      var nextThresholdIndex = 0;
      var trackProgress = function () {
        if (!video.duration) return;
        var progress = (video.currentTime / video.duration) * 100;
        while (nextThresholdIndex < thresholds.length && progress >= thresholds[nextThresholdIndex]) {
          var threshold = thresholds[nextThresholdIndex];
          video.dataset['progress' + threshold] = 'true';
          trackPdpMedia('pdp_video_progress', owner, { media_type: 'video', progress_percent: threshold });
          nextThresholdIndex += 1;
        }
        if (nextThresholdIndex === thresholds.length) video.removeEventListener('timeupdate', trackProgress);
      };
      video.addEventListener('timeupdate', trackProgress);
    }

    if (owner.dataset.userInitiatedPlay === 'true' && !owner.dataset.playTracked) {
      owner.dataset.playTracked = 'true';
      trackPdpMedia('pdp_video_play', owner, { media_type: 'video' });
    }
  }

  function mediaSlides(mediaContainer) {
    var mediaLists = mediaContainer.querySelectorAll('[data-container="carousel"], [data-container="grid"]');

    for (var i = 0; i < mediaLists.length; i += 1) {
      var slides = Array.prototype.filter.call(mediaLists[i].children, function (item) {
        return item.hasAttribute('data-media-id');
      });
      if (slides.length) return slides;
    }

    return [];
  }

  function initializeMediaModuleViewTracking(mainContent) {
    var moduleViewTracked = false;

    var trackWhenMediaReady = function () {
      if (moduleViewTracked || !window.PdpMediaExperiment || !window.PdpMediaExperiment.isEnabled()) return;

      var productContent = mainContent.querySelector('product-content.product--page');
      if (!productContent || !productContent.mediaScopeInitialized) return;

      var experimentVariant = window.PdpMediaExperiment.getVariant();
      var experiment = mainContent.querySelector('[data-experiment-variant="' + experimentVariant + '"]');
      if (!experiment) return;

      var mediaContainerSelector = deviceType() === 'mobile'
        ? '[data-product-mobile-media]'
        : '[data-product-desktop-media]';
      var mediaContainer = experiment.querySelector(mediaContainerSelector);
      if (!mediaContainer) return;

      var slides = mediaSlides(mediaContainer);
      if (!slides.length) return;

      var defaultMediaType = mediaType(slides[0]);
      moduleViewTracked = trackPdpMedia('pdp_media_module_view', mediaContainer, {
        media_type: defaultMediaType,
        default_media_type: defaultMediaType,
        media_count: slides.length
      });
    };

    mainContent.addEventListener('pdp-media-ready', trackWhenMediaReady);
    trackWhenMediaReady();
  }

  function initializeMediaSwipeTracking(mediaContainers) {
    mediaContainers.forEach(function (mediaContainer) {
      var carousels = mediaContainer.querySelectorAll('[data-product-media-carousel-component]');
      carousels.forEach(function (carousel) {
        if (carousel.dataset.mediaSwipeTrackingInitialized === 'true' || carousel.dataset.axis === 'y') return;
        carousel.dataset.mediaSwipeTrackingInitialized = 'true';

        var attachEmblaTracking = function (attempt) {
          if (!carousel.embla) {
            if (attempt < 50 && carousel.isConnected) {
              window.setTimeout(function () {
                attachEmblaTracking(attempt + 1);
              }, 100);
            }
            return;
          }

          var interaction = null;
          var clearTimer = null;

          var setInteraction = function (type, direction) {
            if (clearTimer) window.clearTimeout(clearTimer);
            interaction = {
              type: type,
              direction: direction || null,
              fromIndex: carousel.embla.selectedScrollSnap(),
              tracked: false
            };
          };

          var scheduleInteractionClear = function () {
            if (!interaction) return;
            clearTimer = window.setTimeout(function () {
              interaction = null;
            }, 2000);
          };

          carousel.addEventListener('click', function (event) {
            var arrow = event.target.closest('carousel-button[data-image-only-control]');
            if (!arrow || !carousel.contains(arrow) || arrow.hasAttribute('disabled')) return;
            setInteraction('arrow', arrow.dataset.direction === 'next' ? 'left' : 'right');
            scheduleInteractionClear();
          }, true);

          carousel.embla.on('pointerDown', function () {
            setInteraction('swipe');
          });

          carousel.embla.on('pointerUp', function () {
            scheduleInteractionClear();
          });

          carousel.embla.on('settle', function () {
            if (!interaction || interaction.tracked) return;
            var toIndex = carousel.embla.selectedScrollSnap();
            if (toIndex === interaction.fromIndex) {
              interaction = null;
              return;
            }

            var slides = carousel.embla.slideNodes();
            var fromSlide = slides[interaction.fromIndex];
            var toSlide = slides[toIndex];
            if (!toSlide) {
              interaction = null;
              return;
            }

            interaction.tracked = true;
            trackPdpMedia('pdp_media_swipe', toSlide, {
              from_index: interaction.fromIndex + 1,
              to_index: toIndex + 1,
              swipe_direction: interaction.direction || (toIndex > interaction.fromIndex ? 'left' : 'right'),
              interaction_type: interaction.type,
              to_media_type: mediaType(toSlide),
              from_media_id: fromSlide ? fromSlide.dataset.mediaId : null,
              to_media_id: toSlide.dataset.mediaId || null
            });
            if (clearTimer) window.clearTimeout(clearTimer);
            interaction = null;
          });
        };

        attachEmblaTracking(0);
      });
    });
  }

  function initializePdpMediaInteractions() {
    if (initializePdpMediaInteractions.initialized) return;

    var mainContent = document.getElementById('MainContent');
    if (!mainContent || !mainContent.querySelector('[data-product-media-container]')) return;
    initializePdpMediaInteractions.initialized = true;

    mainContent.addEventListener('click', preparePoiModalPortal, true);
    mainContent.addEventListener('click', handlePdpMediaClick);
    mainContent.addEventListener('keydown', handlePdpMediaKeydown);
    initializePoiModalTracking(mainContent);
  }

  function initializePdpMediaTracking() {
    if (initializePdpMediaTracking.initialized) return;
    if (!window.PdpMediaExperiment || !window.PdpMediaExperiment.isEnabled()) return;

    var mainContent = document.getElementById('MainContent');
    if (!mainContent) return;

    var experimentRoot = mainContent.querySelector('[data-experiment-variant]');
    if (!experimentRoot) return;

    var mediaContainers = mainContent.querySelectorAll('[data-experiment-variant] [data-product-media-container]');
    if (!mediaContainers.length) return;
    initializePdpMediaTracking.initialized = true;

    initializeMediaModuleViewTracking(mainContent);
    initializeMediaSwipeTracking(mediaContainers);

    var observedPoiTriggers = new WeakSet();
    var poiObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var trigger = entry.target;
        var isEffectivelyVisible = entry.isIntersecting && entry.intersectionRatio >= 0.5;

        if (!isEffectivelyVisible) {
          trigger.dataset.poiEligible = 'false';
          if (trigger._poiImpressionTimer) {
            window.clearTimeout(trigger._poiImpressionTimer);
            trigger._poiImpressionTimer = null;
          }
          return;
        }

        if (trigger.dataset.poiImpression || trigger._poiImpressionTimer) return;
        trigger.dataset.poiEligible = 'true';
        trigger._poiImpressionTimer = window.setTimeout(function () {
          trigger._poiImpressionTimer = null;
          if (trigger.dataset.poiEligible === 'true' && !trigger.dataset.poiImpression) {
            trigger.dataset.poiImpression = 'true';
            trackPdpMedia('pdp_poi_impression', trigger, {
              poi_key: trigger.dataset.poiKey,
              poi_label: trigger.dataset.poiLabel
            });
          }
        }, 1000);
      });
    }, { threshold: 0.5 });

    function observePoiTriggers(scope) {
      var triggers = [];
      if (scope.matches && scope.matches('.product-media-poi__trigger')) triggers.push(scope);
      if (scope.querySelectorAll) {
        triggers = triggers.concat(Array.prototype.slice.call(scope.querySelectorAll('.product-media-poi__trigger')));
      }

      triggers.forEach(function (trigger) {
        if (observedPoiTriggers.has(trigger)) return;
        observedPoiTriggers.add(trigger);
        poiObserver.observe(trigger);
      });
    }

    mediaContainers.forEach(function (mediaContainer) {
      observePoiTriggers(mediaContainer);

      var mediaMutationObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType === Node.ELEMENT_NODE) observePoiTriggers(node);
          });
        });
      });
      mediaMutationObserver.observe(mediaContainer, { childList: true, subtree: true });

      mediaContainer.addEventListener('play', handlePdpVideoPlay, true);
    });
  }

  function initializePdpMedia() {
    initializePdpMediaInteractions();
    initializePdpMediaTracking();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializePdpMedia);
  } else {
    initializePdpMedia();
  }
  document.addEventListener('pdp-media-experiment-enable', initializePdpMediaTracking);
})();

// Suppress the global product-image zoom cursor while any point-of-interest trigger is hovered.
(function () {
  if (!window.matchMedia('(hover: hover)').matches) return;

  var zoomCursor;

  function hideZoomCursor() {
    zoomCursor = zoomCursor || document.querySelector('zoom-cursor');
    if (zoomCursor) zoomCursor.classList.remove('is-visible');
    document.body.style.cursor = '';
  }

  function isPoiTrigger(target) {
    return target && target.closest && target.closest('.product-media-poi__trigger');
  }

  document.addEventListener('pointerover', function (event) {
    if (isPoiTrigger(event.target)) hideZoomCursor();
  });

  // zoom-cursor also listens on window mousemove. This listener runs afterwards and keeps it
  // suppressed while the pointer remains over a POI on either an image or video.
  window.addEventListener('mousemove', function (event) {
    if (isPoiTrigger(event.target)) hideZoomCursor();
  });
})();
